import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import './fonts.css';
import { AUTH0_AUDIENCE, AUTH0_DOMAIN, AUTH0_CLIENT_ID } from './settings';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const AppContent = () => (
  <StrictMode>
    <Auth0Provider
      audience={AUTH0_AUDIENCE}
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      redirectUri={window.location.origin}
    >
      <ColorModeScript />

      <App />
    </Auth0Provider>
  </StrictMode>
);

root.render(
  <>
    {window.ENV_CONFIG.keys.posthog_key ? (
      <PostHogProvider
        apiKey={window.ENV_CONFIG.keys.posthog_key}
        options={{
          api_host: window.ENV_CONFIG.keys.posthog_host || '',
          debug: false,
          persistence: 'memory',
        }}
      >
        <AppContent />
      </PostHogProvider>
    ) : (
      <AppContent />
    )}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
